import { useEffect } from 'react'

const SCROLL_LOCKED_ATTR = 'data-scroll-locked'

const RESCUE_BOUNDARY_SELECTOR =
  '[data-radix-popper-content-wrapper], [role="dialog"]'

function findScrollableWithin(
  boundary: HTMLElement,
  target: HTMLElement,
): HTMLElement | null {
  let node: HTMLElement | null = target
  while (node && (node === boundary || boundary.contains(node))) {
    if (node.scrollHeight > node.clientHeight) {
      const { overflowY } = window.getComputedStyle(node)
      if (overflowY === 'auto' || overflowY === 'scroll') return node
    }
    node = node.parentElement
  }
  return null
}

export function useDropdownWheelScrollFix() {
  useEffect(() => {
    const handler = (event: WheelEvent) => {
      if (event.ctrlKey) return
      if (!event.defaultPrevented) return
      if (!document.body.hasAttribute(SCROLL_LOCKED_ATTR)) return
      const target = event.target
      if (!(target instanceof HTMLElement)) return
      const boundary = target.closest<HTMLElement>(RESCUE_BOUNDARY_SELECTOR)
      if (!boundary) return
      const scrollable = findScrollableWithin(boundary, target)
      if (!scrollable) return
      scrollable.scrollTop += event.deltaY
    }
    window.addEventListener('wheel', handler, { passive: true })
    return () => {
      window.removeEventListener('wheel', handler)
    }
  }, [])
}
